module.exports = __webpack_public_path__ + "static/media/006-bronze-cup.4abbbb38.png";